import { Box, Typography } from '@mui/material'
import { IconAdvancedTooltip } from 'assets/icons'

export const HelperInfo = ({
  text,
  title,
}: {
  text: string
  title: string
}) => (
  <Box display="flex" flexDirection="column" py={3.75} px={3}>
    <Box
      display="flex"
      flexDirection="row"
      mb={1.5}
      justifyContent="space-between"
    >
      <Typography variant="caption2" fontWeight={600} color="text.primary">
        {title}
      </Typography>
      <IconAdvancedTooltip
        sx={{
          top: '0',
          right: '0',
          position: 'absolute',
          width: '56px',
          height: '56px',
        }}
      />
    </Box>
    <Typography variant="caption3" whiteSpace="pre-line" color="text.secondary">
      {text}
    </Typography>
  </Box>
)
